import React, { useCallback, useEffect, useState } from "react";
import { AuditNavigationTrace } from "../../types/AuditNavigationTrace";
import { AUDITNAVIGATIONTRACES, GLOBALSETTINGS, SYSTEMSETTINGS } from "../../data/constants";
import useApi from "../../hooks/useApi";
import { GetAllFilesAndFoldersByUserDto } from "../../types/FolderPermission";
import { getRecentViewedItems } from "../../services/roleService";
import { RecentViewedRequestDto } from "../../types/Role";
import { useUser } from "../../context/UserContext";
import { FolderFileType } from "../../data/Enums";
import RecentViewedItems from "./RecentViewedItems";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { clearRecentViewedFolder } from "../../redux/recentViewedSlice";
import { useSettingValue } from "../../services/useSettingValue";
import { getSavedRecentItems } from "../../utils/commonHelper";

const SuggestedFolders: React.FC = () => {
  const [folderData, setFolderData] = useState<GetAllFilesAndFoldersByUserDto[]>([]);
  const { executeApi } = useApi();
  const { userId } = useUser();
  const dispatch = useDispatch();
  const { triggerFolder } = useSelector((state: RootState) => state.recentViewedUpdated);
  const settingValue = useSettingValue(SYSTEMSETTINGS.RECENT_VIEWEDITEMS);

  const getRecentViewedFolders = useCallback(async () => {
    const displaySizeNumber = parseInt(settingValue ?? GLOBALSETTINGS.DEFAULT_VALUE, 10);
    const recentlyViewed: AuditNavigationTrace[] = JSON.parse(
      localStorage.getItem(AUDITNAVIGATIONTRACES.RECENT_VIEWED_FOLDERS) || "[]"
    );
    const recentlyViewedFolders = recentlyViewed
      .filter((item) => item.objectType === FolderFileType[FolderFileType.Folder] && item.objectId)
      .filter((item, index, self) => index === self.findIndex((t) => t.objectId === item.objectId));

    let latestRecentlyViewed = null;

    if (recentlyViewedFolders && recentlyViewedFolders.length > 0) {
      const sortedRecentlyViewed = recentlyViewedFolders.sort((a, b) => {
        return new Date(b.navigationDateTime).getTime() - new Date(a.navigationDateTime).getTime();
      });
      // Get the latest items based on the displaySizeNumber
      latestRecentlyViewed = sortedRecentlyViewed.slice(0, displaySizeNumber);
    }
    let objectIds = null;
    if (latestRecentlyViewed && latestRecentlyViewed.length > 0) {
      objectIds = latestRecentlyViewed.map((item) => item.objectId).join(",");
    }
    const recentViewedRequestDto: RecentViewedRequestDto = {
      userId: userId,
      folderFileType: FolderFileType.Folder,
      typeId: objectIds?.toString(),
      displaySize: displaySizeNumber,
    };

    const fileDetails = await executeApi<RecentViewedRequestDto, GetAllFilesAndFoldersByUserDto[]>(
      getRecentViewedItems,
      recentViewedRequestDto
    );
    if (fileDetails) {
      setFolderData(fileDetails);
      if (objectIds === null) {
        getSavedRecentItems(fileDetails, userId, FolderFileType.Folder);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  useEffect(
    () => {
      getRecentViewedFolders();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(
    () => {
      if (triggerFolder > -1) {
        getRecentViewedFolders();
        dispatch(clearRecentViewedFolder());
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [triggerFolder]
  );

  if (folderData.length === 0) {
    return null;
  }

  return <RecentViewedItems lastViewedItems={folderData} folderFileType={FolderFileType.Folder} />;
};

export default SuggestedFolders;
